import React from 'react';
import { useIntl } from 'react-intl';
import { Checkbox } from '@americanexpress/dls-react';
import { useDispatch, useSelector } from 'react-redux';
import { setIsDriversAgeWithinRangeAction } from '../../../ducks/filtersDuck';
import { getIsDriversAgeWithinRange } from '../../../selectors/filtersSelectors';

const DriversAgeCheckbox = () => {
  const { formatMessage } = useIntl();
  const isDriversAgeWithinRange = useSelector(getIsDriversAgeWithinRange);
  const dispatch = useDispatch();

  const onChange = ({ target: { checked } }) => {
    dispatch(setIsDriversAgeWithinRangeAction(checked));
  };

  return (
    <Checkbox
      id="driversAgeCheckbox"
      label={formatMessage({ id: 'driversAge.checkbox.label' })}
      onChange={onChange}
      checked={isDriversAgeWithinRange}
      value={isDriversAgeWithinRange}
      labelProps={{
        style: {
          paddingLeft: '0px',
          fontWeight: '400',
        },
      }}
    />
  );
};

export default DriversAgeCheckbox;
